import api from "./Api";

class GerenciadorNFCeService {
  ConsultarStatusServico(payload) {
    return api
      .get("/v1/GerenciadorNFCe/ConsultarStatusServico" + payload)
      .then((response) => {
        return response.data;
      });
  }

  ConsultarStatusNFCe(payload) {
    return api
      .get("/v1/GerenciadorNFCe/ConsultarStatusNFCe?cupom=" + payload)
      .then((response) => {
        return response.data;
      });
  }

  TransmitirNFCe(payload) {
    return api
      .get("/v1/GerenciadorNFCe/TransmitirNFCe?cupom=" + payload)
      .then((response) => {
        return response.data;
      });
  }

  ImprimirVenda(payload) {
    return api
      .get("/v1/GerenciadorNFCe/ImprimirVenda/" + payload, {
        responseType: "blob",
      })
      .then((response) => {
        return response;
      });
  }

  DownloadXMLNFCe(payload) {
    return api
      .get("/v1/GerenciadorNFCe/DownloadXMLNFCe/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  CancelarVenda(payload) {
    return api
      .get(
        "/v1/GerenciadorNFCe/CancelarVenda?cupom=" +
          payload.id +
          "&justificativa=" +
          payload.justificativa
      )
      .then((response) => {
        return response.data;
      });
  }

  InutilizarNFCe(payload) {
    return api
      .get("/v1/GerenciadorNFCe/InutilizarNFCe?id=" + payload)
      .then((response) => {
        return response.data;
      });
  }

  EntrarContingenciaNFCe(payload) {
    return api
      .put(
        "/v1/GerenciadorNFCe/EntrarContingenciaNFCe?id=" +
          payload.id +
          "&contingencia=" +
          payload.contingencia
      )
      .then((response) => {
        return response.data;
      });
  }
}

export default new GerenciadorNFCeService();
